import React, { Component } from 'react';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";


function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
        <div
            className={className}
            style={{ ...style, display: "block", background: "red" }}
            onClick={onClick}
        />
    );
}

function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
        <div
            className={className}
            style={{ ...style, display: "block", background: "red" }}
            onClick={onClick}
        />
    );
}
export class Layer5 extends Component { 

  constructor(props) {        
      super(props);
    this.state={  
        currentSlide: 0,          
        TMentorz:[
            {
                id:1,                           
                image:'assets/images/homepage/Match.png',                    
            },
            {
                id:2,             
                image:'assets/images/homepage/Learn.png',
            },
            {
                id:3,                              
                image:'assets/images/homepage/Grow.png',
            },
          ],
            
          settings:{
             dots: true,
             infinite: false,
             speed: 500,
             slidesToShow: 1,
             slidesToScroll: 1,             
              centerMode: true,
              beforeChange: this.beforeSlideChange,  
              nextArrow: <SampleNextArrow />,
              prevArrow: <SamplePrevArrow />

           }
           

     }            
     
    }
  


    beforeSlideChange = (current, next) => {
      this.setState({ currentSlide: next });
    };

    render() {
        return (
            <div className="">
                <div className="section-main container">
                <div className='row'>
                  <div className='col-lg-12 col-sm-12'>
                    <div className='headingformula'>Our formula: <span className='mentorzcolor'>Your Success</span></div>
                            <div className='textcenter p-20'>
                  <span className='forind'>For individuals</span>
                  <span className='standline'> | </span>
                  <span className='forenterprise'>For Enterprises</span>
                </div>
                  </div>
                </div>
               <div className='spacemargin'></div>
                <div className='row'>
                  <div className='col-lg-4 col-sm-12'>  
                   <Slider {...this.state.settings}>  
                {this.state.TMentorz.map((result, index) => { 
                return (                  
                    <div key={index}>
                       <img  src={result.image} className='primarybtn matchimg' alt="mentor_1"/>                     
                    </div>
                )
              })}
              </Slider>
                   
                  </div>
                  <div className='col-lg-1 col-sm-12'></div>
                  <div className='col-lg-7 col-sm-12'>
                    <div className='row'>
                      <div className='col-lg-12 col-sm-12'>
                        <div className='matchheading'>
                        1.   Match
                        </div>
                        <div class="matchdesc">
                            Discover mentors and access mentorship opportunities based on their expertise, shared interests, and values.
                        </div>                       
                      </div>
                    </div>
                    <div className='row'>
                    <div className='col-lg-12 col-sm-12'>
                        <div className='learnheading'>
                        2.   Learn
                        </div>
                        <div class="matchdesc">
                        Gain insights from industry experts, receive guidance, embark on self-discovery, and track your personal growth.
                        </div>                       
                      </div>
                    </div>
                    <div className='row'>
                    <div className='col-lg-12 col-sm-12'>
                        <div className='learnheading'>
                        3.   Grow
                        </div>
                        <div class="matchdesc">
                        Reflect on mentorship insights, celebrate achievements, and set your sights on fresh goals.
                        </div>                       
                      </div>
                    </div>
                  </div>
                </div>
        </div>
      </div>
        );
    }
}
